<template>
    <div v-if="permissions && $getPermission(permissions,37).is_granted" class="sm:ml-24 relative mt-3 mb-20 max-w-7xl bg-squares dark:bg-dark.tableBG text-panelsText dark:text-dark.textOnBkg sm:p-5 sm:rounded-lg sm:border border-sepBorder dark:border-dark.sepBorder">
        <slot v-if="monthly_billing.length>0">
            <div class="bg-gray-100 grid grid-cols-4 sm:grid-cols-6 gap-4 w-full p-3 border border-sepBorder dark:border-dark.sepBorder sm:rounded-t-lg text-center font-semibold text-gray-600 dark:text-dark.textOnBkg dark:bg-dark.panels">
                <div class="pl-2 sm:pl-10 col-span-2 text-left">{{ $t('invoice_for') }}</div>
                <div>{{ $t('amount') }}</div>
                <div class="hidden sm:block">{{ $t('issued') }}</div>
                <div class="hidden sm:block">{{ $t('status') }}</div>
                <div></div>
            </div>
            <div class="w-full col-span-6 grid grid-cols-4 sm:grid-cols-6 gap-4 p-3 py-5 text-center border border-t-0 border-sepBorder dark:border-dark.sepBorder text-gray-500 dark:text-dark.textOnBkg" v-for="(bill,index) in monthly_billing" :key="index">
                <div class="pl-2 sm:pl-10 col-span-2 text-left font-semibold text-sm">{{ $moment(bill.date_from).format('DD.MM.') + ' - ' + $moment(bill.date_to).format('DD.MM.YYYY')}}</div>
                <div><span class="hidden sm:contents">{{bill.currency}} </span> {{bill.total_amount}}</div>
                <div class="hidden sm:block">{{$moment(bill.created_at).format('DD.MM.YYYY')}}</div>
                <div class="hidden sm:block w-max rounded mx-auto p-0.5 px-2 text-sm font-semibold" :class="!bill.paid ? 'bg-decline bg-opacity-10 text-decline' : 'bg-growth bg-opacity-10 text-growth'">
                    <font-awesome-icon v-if="bill.paid" icon="fas fa-check" class="mr-1" />
                    <font-awesome-icon v-else icon="fas fa-times" class="mr-1" />
                    {{bill.paid == true ? $t('paid'): $t('not_paid')}}
                </div>
                <div class="cursor-pointer" @click="openDetail(index, bill.id)">
                    <font-awesome-icon v-if="bill.open" icon="fa-solid fa-chevron-up" />
                    <font-awesome-icon v-else :icon="['fas', 'chevron-down']" />
                </div>
                <div v-if="bill.loading" class="col-span-full text-center text-gray-500">
                    <font-awesome-icon icon="fas fa-spinner fa-spin" class="animate-spin"/>
                </div>
                <section class="col-span-full text-left leading-loose m-2 mx-1 sm:mx-5 rounded-lg border border-sepBorder dark:border-dark.sepBorder dark:border-dark.sepBorder" v-show="bill.open">
                    <div class="bg-gray-100 grid grid-cols-3 sm:grid-cols-6 gap-4 w-full p-3 border border-sepBorder dark:border-dark.sepBorder dark:border-dark.sepBorder sm:rounded-t-lg text-center font-semibold text-gray-600 dark:text-dark.textOnBkg dark:bg-dark.panels">
                        <div class="pl-2 text-left">{{ $t('creator') }}</div>
                        <div>{{ $t('platform') }}</div>
                        <div class="hidden sm:block">{{ $t('active_days') }}</div>
                        <div class="hidden sm:block">{{ $t('cost_basic') }}</div>
                        <div class="hidden sm:block">{{ $t('add_ons') }}</div>
                        <div>{{ $t('summary') }}</div>
                    </div>
                    <div>
                        <div class="grid grid-cols-3 sm:grid-cols-6 px-3 border-b border-sepBorder dark:border-dark.sepBorder dark:border-dark.sepBorder py-1" v-for="(detail,index) in bill.invoice_items" :key="index">
                            <div>{{detail.name}}</div>
                            <div class="w-20 mx-auto">
                                <slot v-if="detail.platform==1"><img src="@/assets/images/of_logo.png" title="Onlyfans" alt="Onlyfans" class="mt-1.5 h-5 mx-auto"/></slot>
                                <slot v-else-if="detail.platform==2"><img src="@/assets/images/fansly_logo.png" title="Fansly" alt="Fansly" class="mt-1.5 h-5 mx-auto"/></slot>
                            </div>
                            <div class="hidden sm:block text-center">
                                <span>{{detail.total_days}}</span>
                            </div>
                            <div class="hidden sm:block text-center">
                                <span>{{bill.currency == 'USD' ? '$' : '€'}} {{detail.total_cost.toFixed(2)}}</span>
                            </div>
                            <div v-if="detail.tools" class="hidden sm:block text-center">
                                <span>{{bill.currency == 'USD' ? '$' : '€'}} {{(detail.tools.reduce((toolsTotal,item) => toolsTotal + item.final_cost, 0) + (detail.proxy === true ? 1 : 0)).toFixed(2)}}</span>
                            </div>
                            <div class="text-center">
                                <span>{{bill.currency == 'USD' ? '$' : '€'}} {{(detail.total_cost + detail.tools.reduce((toolsTotal,item) => toolsTotal + item.final_cost, 0) + (detail.proxy === true ? 1 : 0)).toFixed(2)}}</span>
                            </div>
                        </div>
                        <div v-if="bill?.invoice_items" class="col-span-full bg-gray-100 grid grid-cols-3 sm:grid-cols-6 w-full p-1 sm:rounded-b-lg text-center font-semibold text-gray-600 dark:text-dark.textOnBkg dark:bg-dark.panels">
                            <div class="pl-2 text-left">{{ $t('summary') }}</div>
                            <div class="hidden sm:block col-start-4">{{ bill.currency == 'USD' ? '$' : '€' }} {{bill.invoice_items.reduce((total, item) => total + item.total_cost, 0).toFixed(2)}}</div>
                            <div class="hidden sm:block">
                                {{ bill.currency == 'USD' ? '$' : '€' }} 
                                {{(bill?.invoice_items.reduce((total, detailItem) => total + (detailItem.tools ? detailItem.tools.reduce((toolsTotal, item) => toolsTotal + item.final_cost, 0) : 0) + (detailItem.proxy === true ? 1 : 0), 0)).toFixed(2)}}
                            </div>
                            <div v-if="bill?.invoice_items?.length>0" class="pr-5 col-start-3 sm:col-start-auto text-center">{{ bill.currency == 'USD' ? '$' : '€' }} {{
                                (
                                    bill.invoice_items.reduce((total, item) => total + item.total_cost, 0) +
                                    bill.invoice_items.reduce((total, detailItem) => 
                                        total + (detailItem.tools ? detailItem.tools.reduce((toolsTotal, item) => toolsTotal + item.final_cost, 0) : 0)
                                    , 0)
                                    + bill.invoice_items.reduce((total, item) => total + (item.proxy === true ? 1 : 0), 0)
                                ).toFixed(2)
                            }}</div>
                        </div>
                    </div>
                </section>
            </div>
        </slot>
        <div class="text-center my-5" v-else-if="loading"><font-awesome-icon icon="fas fa-spinner" class="animate-spin text-textOnBkg dark:text-dark.textOnBkg" /></div>
        <div class="text-center my-5" v-else>{{ $t('no_invoices_yet') }}</div>
    </div>
    <div v-else-if="permissions != null && (!$getPermission(permissions,37).is_granted)" class="text-center mt-52 text-textOnBkg dark:text-dark.textOnBkg">
        {{ $t("no_permission") }}
    </div>
</template>

<script>
    import { useAuthStore } from '@/stores/auth';
    import { get_monthly_billing, invoice_details, api_get_call } from "@/api/api"
    export default {
        data() {
            return {
                monthly_billing: [],
                loading:false,
            }
        },
        computed: {
            authStore() {
                return useAuthStore();
            },
            myself() {
                return this.authStore.myself;
            },
            permissions() {
                return this.authStore.permissions;
            },
        },
        methods: {
            async openDetail(index, invoice_id) {
                if (this.monthly_billing[index].open == false && this.monthly_billing[index].detail == null) {
                    this.monthly_billing[index].loading = true;
                    let invoice_detail = await invoice_details(this.$cookies.get('userToken'),this.$cookies.get('c_id'), invoice_id);
                    this.monthly_billing[index].invoice_items = invoice_detail.invoice_items;
                    this.monthly_billing[index].loading = false;
                }
                this.monthly_billing[index].open = !this.monthly_billing[index].open;
            }
        },
        async created() {
            this.loading = true;
            this.monthly_billing = await get_monthly_billing(this.$cookies.get('userToken'),this.$cookies.get('c_id'), 0, 10);
            
            this.loading = false;
        }
    }
</script>